<template>
  <div class="timeframe-options">
    <div class="radio-group">
      <HgRadioButton
        v-for="timeframe in Object.values(TimeframeOptions)"
        :key="timeframe"
        :modelValue="modelValueAsString"
        :disabled="false"
        :inputValue="timeframe"
        :label="t(`csvExport.${timeframe}`)"
        name="timeframe"
        @update:model-value="handleUpdate($event)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { TimeframeOptions } from '@/helpers/fetchAndDownloadLeadsExport';
import { HgRadioButton } from '@smg-real-estate/domus';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  modelValue: TimeframeOptions;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: TimeframeOptions): void;
}>();

const { t } = useI18n();

const modelValueAsString = computed(() => props.modelValue.toString());

const handleUpdate = (value: string) => {
  emit('update:modelValue', value as TimeframeOptions);
};
</script>

<style scoped>
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
